import PropTypes from 'prop-types';

const fontConfigTypes = {
  family: PropTypes.string,
  scaleFactor: PropTypes.number,
  source: PropTypes.oneOf(['google', 'typekit', 'local']),
  kitId: PropTypes.string,
  weights: PropTypes.arrayOf(PropTypes.number),
  fallbacks: PropTypes.string,
};

export default {
  theme: PropTypes.oneOf(['light', 'dark']),
  accentColor: PropTypes.string,
  fontBody: PropTypes.shape(fontConfigTypes),
  fontCaption: PropTypes.shape(fontConfigTypes),
  fontHeading: PropTypes.shape(fontConfigTypes),
  fontUi: PropTypes.shape(fontConfigTypes),
  footerText: PropTypes.string,
  logo: PropTypes.string,
  logoLink: PropTypes.string,
  promo1Image: PropTypes.string,
  promo1Link: PropTypes.string,
  promo2Image: PropTypes.string,
  promo2Link: PropTypes.string,
  promoText: PropTypes.string,
};
